function checkIsPeerIdRemotePeerId(ownPeerInfo, remotePeerId) {
  const ownPeerId = ownPeerInfo?.peerId;
  return !!(ownPeerId && ownPeerId !== remotePeerId);
}

export default checkIsPeerIdRemotePeerId;
